import script from "./UserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=7f4c629e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4c629e"]])

export default __exports__